import { AuthCallback as AuthCallbackComponent } from "@/lib/auth";

export default function AuthCallbackRoute() {
  return <AuthCallbackComponent />;
}
